
import { useParams } from 'react-router-dom';
import { PostEditor } from '../features/blog/components/PostEditor/PostEditor';

export const BlogEditorPage = () => {
  const { id } = useParams();
  return <PostEditor postId={id} />;
};
